import { isPrivilegedRole } from "@adpilot/shared";
import type { User } from "@/stores/auth";

export function getActiveWorkspaceRole(user: User | null) {
  if (!user?.activeWorkspaceId) return null;
  return (
    user.workspaces?.find((workspace) => workspace.id === user.activeWorkspaceId)?.role ?? null
  );
}

export function canManageAmazonForActiveWorkspace(user: User | null): boolean {
  return isPrivilegedRole(getActiveWorkspaceRole(user));
}
